const DebtStatusEnum = {
    1: {
        label: "Dívida contestada",
        color: "#EB6878",
        key: "CONTESTED"
    },
    2: {
        label: "Pendente",
        color: "#F39C12",
        key: "PENDING"
    },
    3: {
        label: "Paralisada",
        color: "#B7C7D2",
        key: "PARALYZED"
    },
    4: {
        label: "Em cobrança",
        color: "#06BCED",
        key: "IN_CHARGE"
    },
    5: {
        label: "Inativo",
        color: "#B7C7D2",
        key: "INACTIVE"
    },
    6: {
        label: "Dívida paga",
        color: "#45D256",
        key: "DEBT_PAID"
    },
    7: {
        label: "Dívida renegociada",
        color: "#B7C7D2",
        key: "DEBT_RENEGOTIATED"
    }
};

export default DebtStatusEnum;
